import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

export const OLA_MAPS_AUTOCOMPLETE_API_KEY = Config.OLA_SEARCH_API_KEY

export const API_CONTENT_TYPE = 'application/json'

export const API_METHOD = 'GET'

export const MAP_CENTER_POINT = {
   latitude: 17.7291808,
   longitude: 79.139446
}

export const RADIUS_IN_METERS = 300000

export const OLA_MAPS_CUSTOM_ATTRIBUTION =
   '<a href="https://openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">Ola Maps</a>'
